// Shared character-search helper. Used by every character picker (channel
// invite, RP scene characters, RP "playing as", DM identity picker) so a
// first-name search like "layla" reliably finds "Princess Layla Summerfall"
// and "evie" finds "Evelyn (Evie)".
//
// Pre-fix the searches were `c.name.toLowerCase().includes(q)` which missed
// characters where the first name was buried in a title or nickname or
// where the user typed an alias (id/keyword/trait).

/**
 * @param {object} char - character object from CHARACTERS array
 * @param {string} query - raw search query
 * @returns {boolean}
 */
export function matchesCharacterSearch(char, query) {
  if (!query) return true;
  const q = String(query).toLowerCase().trim();
  if (!q) return true;
  if (!char) return false;
  const haystack = [
    char.name,
    char.fullName,
    char.id,
    char.subtitle,
    char.species,
    ...(Array.isArray(char.keywords) ? char.keywords : []),
    ...(Array.isArray(char.traits) ? char.traits : []),
  ].filter(Boolean).map(v => String(v).toLowerCase()).join(' ');
  if (haystack.includes(q)) return true;
  // Token match: every word of the query must appear SOMEWHERE in the
  // haystack, so "aunt amelda" finds a character named "Amelda" whose
  // keywords include "aunt" — the phrase itself never appears as one string.
  // Single-word queries are already covered by the substring check above.
  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length < 2) return false;
  return tokens.every(t => haystack.includes(t));
}
